<template>
  <div class="role-tree">
    <div class="role-tree-search">
      <Input
        search
        placeholder="输入角色组、角色"
        class="searchTop"
        v-model="filterText"
      />
      <Button type="primary" @click="handlerAddGroup()">添加角色组</Button>
    </div>
    <el-tree
      highlight-current
      node-key="id"
      :render-content="renderContent"
      @node-click="handlerSelected"
      :expand-on-click-node="false"
      :filter-node-method="filterNode"
      draggable
      ref="tree"
      :data="rolesData"
      default-expand-all
    ></el-tree>

    <!-- 弹出框 -->
    <Modal
      v-model="modalStatus"
      :title="modalTitle"
      :mask-closable="false"
      :closable="false"
    >
      <div style="text-align: center;color: #17233d;font-size: 14px;">
        <Input
          prefix="ios-paper-plane"
          :placeholder="placeholderType"
          style="width:300px"
          v-model="editNode"
        />
      </div>
      <div slot="footer">
        <Button @click="submitCancel">取消</Button>
        <Button type="primary" @click="submitOk">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      modalStatus: false,
      placeholderType: "",
      modalTitle: "",
      editNode: "",
      modalType: "",
      rolesData: [],
      //记录触发事件节点
      node: {
        id: "",
        roleGroupId: "",
      },
      //要过滤的数据
      filterText: "",
      //向表格主体发送数据
      roleSelected: {
        id: "",
        name: "",
      },
    };
  },
  created() {
    //获取数据
    this.handlerGetRoles();
  },
  watch: {
    //筛选数据
    filterText(val) {
      this.$refs.tree.filter(val);
    },
    roleSelected: {
      handler(val) {
        this.$observer.$emit("getRoleSelected", val);
      },
      deep: true,
    },
  },
  computed: {},
  methods: {
    //提交请求
    submitCancel() {
      this.editNode = "";
      this.modalStatus = false;
    },
    submitOk() {
      if (this.editNode.length > 20) {
        this.$Message.info("输入过长,请重新输入");
        return;
      }
      switch (this.modalType) {
        case "addRoles":
          this.$api
            .addRole({
              roleGroupId: this.node.id,
              roleName: this.editNode,
            })
            .then(() => {
              this.modalStatus = false;
              this.$Message.success("添加成功！");
              this.handlerGetRoles();
              this.editNode = "";
            });

          break;
        case "editRoles":
          this.$api
            .editRole({
              id: this.node.id,
              roleGroupId: this.node.roleGroupId,
              roleName: this.editNode,
            })
            .then(() => {
              this.modalStatus = false;
              this.$Message.success("修改成功！");
              this.$observer.$emit("refsData");
              if (this.node.id == this.roleSelected.id) {
                this.roleSelected.name = this.editNode;
              }
              this.handlerGetRoles();
              this.editNode = "";
            });
          break;
        case "addRoleGroups":
          this.$api
            .addRoleGroups({
              roleGroupName: this.editNode,
            })
            .then(() => {
              this.modalStatus = false;
              this.$Message.success("添加成功！");
              this.handlerGetRoles();
              this.editNode = "";
            });
          break;
        case "editRoleGroups":
          this.$api
            .editRoleGroups({
              id: this.node.id,
              roleGroupName: this.editNode,
            })
            .then(() => {
              this.modalStatus = false;
              this.$Message.success("修改成功！");
              this.handlerGetRoles();
              this.editNode = "";
            });
          break;
        default:
          break;
      }
    },
    //获取角色树数据
    handlerGetRoles() {
      this.$api
        .getRoles({
          getAll: true,
        })
        .then((data) => {
          this.rolesData = data.map((item) => {
            return {
              id: item.id,
              label: item.roleGroupName,
              roleGroupId: "",
              children: item.roleDOS
                ? item.roleDOS.map((n) => {
                    return {
                      id: n.id,
                      label: n.roleName,
                      roleGroupId: n.roleGroupId,
                    };
                  })
                : [],
            };
          });
          //设置当前高亮节点
          this.$nextTick(() => {
            //判断默认数据
            if (this.roleSelected.id) {
              this.$refs.tree.setCurrentKey(this.roleSelected.id);
            } else {
              //删选出管理员id
              var administratorId = this.rolesData
                .filter((item) => {
                  return item.label === "默认分组";
                })[0]
                .children.filter((n) => {
                  return n.label === "管理员";
                })[0].id;
              this.$refs.tree.setCurrentKey(administratorId);
              this.roleSelected.id = administratorId;
              this.roleSelected.name = "管理员";
            }
          });
        });
    },
    //选中的节点
    handlerSelected(data) {
      if (!data.roleGroupId) {
        return;
      }
      this.highlight = true;
      this.roleSelected.id = data.id;
      this.roleSelected.name = data.label;
    },
    remberData(data) {
      this.node.id = data.id;
      this.node.roleGroupId = data.roleGroupId;
      this.modalStatus = true;
    },
    //新增角色组
    handlerAddGroup() {
      this.modalStatus = true;
      this.placeholderType = "请输入角色组名称：";
      this.modalTitle = "添加角色组";
      this.modalType = "addRoleGroups";
    },
    //新增角色
    append(data) {
      this.remberData(data);
      this.placeholderType = "请输入角色名称：";
      this.modalTitle = "添加角色";
      this.modalType = "addRoles";
    },
    //编辑角色组或者角色
    edit(data) {
      this.remberData(data);
      this.editNode = data.label;
      if (data.roleGroupId) {
        this.placeholderType = "请输入新的角色名称：";
        this.modalTitle = "编辑角色";
        this.modalType = "editRoles";
      } else {
        this.placeholderType = "请输入新的角色组名称：";
        this.modalTitle = "编辑角色组";
        this.modalType = "editRoleGroups";
      }
    },
    //删除角色或者角色组
    remove(data) {
      this.node.id = data.id;
      this.node.roleGroupId = data.roleGroupId;
      if (data.roleGroupId) {
        this.$Modal.confirm({
          title: "确定要将该角色删除吗？",
          onOk: () => {
            this.$api
              .deleteRole({
                id: data.id,
              })
              .then(() => {
                this.$Message.success("删除成功");
                this.handlerGetRoles();
              });
          },
        });
      } else {
        this.$Modal.confirm({
          title: "确定要将该角色组吗？",
          onOk: () => {
            this.$api
              .deleteRoleGroups({
                id: data.id,
              })
              .then(() => {
                this.$Message.success("删除成功");
                this.handlerGetRoles();
              });
          },
        });
      }
    },

    hasActionPermission(label) {
      const whiteList = ["默认分组", "管理员", "boss", "财务", "出纳", "人事"];
      return !whiteList.includes(label);
    },

    //过滤节点
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },

    //       //拖拽
    //       allowDrop(draggingNode, dropNode, type) {
    //         if (!dropNode.parent.parent) {
    //           return type == 'inner';
    //         } else {
    //           return type !== 'inner';
    //         }
    //       },
    //       allowDrag(draggingNode) {
    //         if (!draggingNode.parent.parent) {
    //           return false
    //         } else {
    //           switch (draggingNode.data.label) {
    //             case 'boss':
    //               return false
    //             case '管理员':
    //               return false
    //             default:
    //               return true
    //           }
    //         }

    // },
    renderContent(h, { node, data, store }) {
      return (
        <div class="custom-tree-node">
          <div class="iconStyle">
            <i
              class="el-icon-plus"
              on-click={(e) => {
                e.stopPropagation();
                this.append(data);
              }}
              v-show={!node.parent.parent}
            >
              {" "}
            </i>{" "}
            <i
              class="el-icon-edit"
              on-click={(e) => {
                e.stopPropagation();
                this.edit(data);
              }}
              v-show={this.hasActionPermission(data.label)}
            >
              {" "}
            </i>{" "}
            <i
              class="el-icon-delete"
              on-click={(e) => {
                e.stopPropagation();
                this.remove(data, node);
              }}
              v-show={this.hasActionPermission(data.label)}
            >
              {" "}
            </i>{" "}
          </div>
          <el-tooltip
            class="omitStyle"
            effect="dark"
            content={node.label}
            placement="bottom-start"
            open-delay={500}
          >
            <div> {node.label} </div>
          </el-tooltip>
        </div>
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.role-tree {
  ::v-deep .custom-tree-node {
    width: 300px;
    height: 20px;
    padding-right: 8px;
    line-height: 20px;
    font-size: 16px;
  }
  ::v-deep .custom-tree-node:after {
    content: "";
    height: 0;
    line-height: 0;
    display: block;
    visibility: hidden;
    clear: both;
  }
  ::v-deep .iconStyle {
    float: right;
  }
  ::v-deep .el-tree-node {
    margin: 8px 0 0 0;
  }
  ::v-deep .el-icon-plus,
  ::v-deep .el-icon-edit,
  ::v-deep .el-icon-delete {
    width: 30px;
  }
  /* 省略号样式 (莫名其妙的样式)*/
  ::v-deep .omitStyle {
    max-width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .role-tree-search {
    height: 50px;
    width: 320px;
  }
  .searchTop {
    width: 200px;
    margin-right: 10px;
  }
}
</style>
